/**
 * Which CaseApi answers: always the HTTP API. There is no fixture mode in any build (a local build used to select
 * fixtures on localhost and showed fake cases). Tests swap the instance with `setCaseApi` (see test-utils.tsx), and so
 * does Playwright's fixture app (e2e/app/main.ts, `vite build --mode e2e` into dist-e2e, never deployed).
 * Owner: web-case-composer (slice 16).
 */
import { queryOptions } from '@tanstack/react-query'
import { createHttpCaseApi } from './http'
import type { CaseApi } from './port'

let current: CaseApi = createHttpCaseApi()

export const caseApi = (): CaseApi => current

export function setCaseApi(api: CaseApi): void {
  current = api
}

/** Query keys follow the SSE invalidation keys: ['case', id] invalidates every section below. */
export const caseKeys = {
  case: (id: string) => ['case', id] as const,
  section: (id: string, section: string) => ['case', id, section] as const,
  me: ['me', 'desk-token'] as const,
  sendState: (threadUuid: string) => ['send-state', threadUuid] as const,
  recipients: (threadUuid: string) => ['recipients', threadUuid] as const,
}

export const caseViewQuery = (id: string) => queryOptions({ queryKey: caseKeys.case(id), queryFn: () => current.getCase(id) })

export const meDeskQuery = () => queryOptions({ queryKey: caseKeys.me, queryFn: () => current.me(), staleTime: 30_000 })

export * from './edit-types'
export type { CaseApi, CaseTitleSuggestion, CloseConversationIn, CloseConversationOut, PaneActionOut, UpdateFormView } from './port'
export { greetingOf, textOf } from './text'
export * from './types'
